import { render } from "./Per_week.vue?vue&type=template&id=6a7f7d70&scoped=true"
import script from "./Per_week.vue?vue&type=script&lang=js"
export * from "./Per_week.vue?vue&type=script&lang=js"

import "./Per_week.vue?vue&type=style&index=0&id=6a7f7d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7f7d70"]])

export default __exports__